import * as R from 'ramda';
import { ActionType } from '../../core/redux/actionType';
import { AppState } from '../../core/redux/appState';
import { Action } from 'redux';


type SetDateRangeAction = {
  type: ActionType.SetDateRange;
  dateRange: number;
}


/**
 * Dispatch this set the report recipient date range.
 * @param dateRange - the new date range state you want (default: 3)
 */
export const setDateRangeAction = (dateRange: number = 3): SetDateRangeAction => ({
  type:      ActionType.SetDateRange,
  dateRange: dateRange,
});


export const setDateRangeReducer = (state: AppState, incomingAction: Action): AppState => {
  if (incomingAction.type !== ActionType.SetDateRange) {
    return state;
  }

  const action = incomingAction as SetDateRangeAction;

  return R.assoc('reportRecipientDateRange', action.dateRange, state);
};
